import { FC } from "react";
import SmartSearchDateIntervalSelectAndActionsLayout from "../../../components/Layouts/smart-search-date-interval-select-and-actions-layout";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import { DateFormatEnum } from "../../../enums/dateFormatEnum";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import {
  GetLargeCashOutParams,
  getLargeCashOut,
} from "../../../services/reports";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";

const LargeCashOut: FC = () => {
  return (
    <SmartSearchDateIntervalSelectAndActionsLayout
      searchBy={[
        SearchOptionEnum.DISTRIBUTOR,
        SearchOptionEnum.CHARITY,
        SearchOptionEnum.LOCATION,
      ]}
      actions={[
        ActionButtonEnum.REFRESH,
        ActionButtonEnum.SAVE_CSV,
        ActionButtonEnum.SAVE_PDF,
      ]}
      validOnEmpty
      onRefresh={(output, params, startDateInterval, endDateInterval) => {
        const getLargeCashOutParams: GetLargeCashOutParams = {
          output,
          beginDate: startDateInterval.format(DateFormatEnum.MONTH_DAY_YEAR),
          endDate: endDateInterval.format(DateFormatEnum.MONTH_DAY_YEAR),
        };

        if (params.id) {
          const id = createIdFromSmartSearchParams(params);
          getLargeCashOutParams[id] = params.id;
        }

        return getLargeCashOut(getLargeCashOutParams);
      }}
    />
  );
};

export default LargeCashOut;
